<template>
  <div class="resume-banner">
    <h2 class="title">Собери резюме для отклика</h2>
    <p class="text">
      Заполни профиль один раз — и откликайся на стажировки и практики в АПК быстрее
    </p>
    <div class="button-wrapper">
      <BaseButton
        class="button"
        name="Разместить резюме"
        border-radius="medium"
        @click="createResume"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButton } from '~/components/base-ui/buttons'
  import { useAuthModal } from '~/composables/use-auth-modal'
  import { useAuth } from '~/composables/use-auth'

  const img = useImage()
  const bgImageUrl = `url(${img('/banners/resume/bg-image.png', { format: 'webp' })})`
  const bgImageMobileUrl = `url(${img('/banners/resume/bg-image-mobile.png', { format: 'webp' })})`

  const router = useRouter()
  const { isAuth } = useAuth()
  const { openModal } = useAuthModal()

  const createResume = () => {
    const url = '/account/candidate/resumes/create'

    if (!isAuth.value) {
      openModal({ backUrl: url })
      return
    }
    router.push(url)
  }
</script>

<style lang="scss" scoped>
  .resume-banner {
    width: 100%;
    padding: 48px;
    background-color: #bae6c8;
    background-image: v-bind(bgImageUrl);
    background-position: top right;
    background-size: auto 100%;
    background-repeat: no-repeat;
    border-radius: 32px;

    @include vp-1279 {
      padding: 24px;
      border-radius: 24px;
    }

    @include vp-1023 {
      background-position: top right -124px;
    }

    @include vp-767 {
      padding-bottom: 290px;
      background-image:
        v-bind(bgImageMobileUrl),
        linear-gradient(to top, #e9e7ac 53%, rgb(210 233 186 / 0%) 100%);
      background-size:
        100% auto,
        100% auto;
      background-position:
        bottom center,
        center top;
    }

    > .title {
      margin-bottom: 8px;
      font-size: 44px;
      font-weight: 600;
      line-height: 52px;

      @include vp-1279 {
        max-width: 260px;
        font-size: 28px;
        line-height: 32px;
      }
    }

    > .text {
      max-width: 550px;
      margin-bottom: 32px;
      font-size: 24px;
      line-height: 32px;

      @include vp-1279 {
        max-width: 260px;
        margin-bottom: 16px;
        font-size: 18px;
        line-height: 26px;
      }
    }

    > .button-wrapper {
      position: relative;
      width: fit-content;

      &::after {
        position: absolute;
        content: '';
        top: -15px;
        right: -65px;
        width: 50px;
        height: 80px;
        background-image: url('~/assets/images/banners/resume/three-lines-banner.svg');
        background-repeat: no-repeat;
        background-size: contain;

        @include vp-1279 {
          top: -10px;
          right: -40px;
          width: 31px;
          height: 50px;
        }
      }

      > .button {
        @include vp-1279 {
          height: 48px;
        }
      }
    }
  }
</style>
